import { render, staticRenderFns } from "./SidebarComponent.vue?vue&type=template&id=b946f3f2&scoped=true&"
import script from "./SidebarComponent.vue?vue&type=script&lang=ts&"
export * from "./SidebarComponent.vue?vue&type=script&lang=ts&"
import style0 from "./SidebarComponent.vue?vue&type=style&index=0&id=b946f3f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b946f3f2",
  null
  
)

export default component.exports